type Listener<TArgs = unknown, TResult = never> = (args: TArgs) => TResult;

export class EventEmitter {
	private events: Record<string, Listener<any, any>[]> = {};

	on<TArgs, TResult>(event: string, listener: Listener<TArgs, TResult>): void {
		if (!this.events[event]) {
			this.events[event] = [];
		}

		if (!this.events[event].includes(listener)) {
			this.events[event].push(listener);
		}
	}

	off<TArgs, TResult>(event: string, listener: Listener<TArgs, TResult>): void {
		if (!this.events[event]?.length) return;

		this.events[event] = this.events[event].filter((l) => l !== listener);
	}

	emit<TArgs, TResult>(event: string, data: TArgs): TResult[] {
		const listeners = this.events[event] as Listener<TArgs, TResult>[];
		if (!listeners) return [];

		return listeners.map((listener) => listener(data));
	}
}
